import { Alert, Anchor } from '@zillow/constellation-10';

const ListingPostedForSaleBanner = ({ forSaleUrlOnZillow }: { forSaleUrlOnZillow: string }) => {
  const learnMore = (
    <Anchor
      href="https://www.zillow.help/article/advertising-for-sale-and-for-rent-listings-simultaneously-zd30237388907539"
      target="_blank"
      rel="noopener noreferrer"
    >
      Learn more
    </Anchor>
  );

  const alreadyPostedForSale = forSaleUrlOnZillow ? (
    <span>
      <Anchor href={forSaleUrlOnZillow} target="_blank" rel="noopener noreferrer">
        already posted
      </Anchor>{' '}
      for sale
    </span>
  ) : (
    <span>already posted for sale elsewhere</span>
  );

  return (
    <Alert tone="info" css={{ marginBottom: '400' }}>
      This property was {alreadyPostedForSale}. You can post it for rent at the same time, but it may receive less
      visibility. {learnMore}
    </Alert>
  );
};

export default ListingPostedForSaleBanner;
